export type SellerAdminChatContactScope = "seller" | "admin_peer";

export type SellerAdminChatContact = {
  id: number;
  scope?: SellerAdminChatContactScope;
  name: string;
  subtitle?: string | null;
  unread_count: number;
  preview?: string | null;
  last_message_at?: string | null;
  conversation_sid?: string | null;
  call_identity?: string;
  photo_url?: string | null;
  is_online?: boolean;
  urls: {
    token: string;
    messages: string;
    send: string;
    read: string;
  };
};

export type SellerAdminChatVoiceStatus = {
  enabled: boolean;
  missing?: string[];
};

export type SellerAdminChatAttachment = {
  id: number | null;
  filename: string;
  mime?: string | null;
  size?: number | null;
  url?: string | null;
  is_image?: boolean;
};

export type SellerAdminChatMessage = {
  kind?: "message";
  id: number;
  body?: string | null;
  sender_type: "seller" | "admin";
  sender_id: number;
  created_at: string;
  attachments?: SellerAdminChatAttachment[];
  attachment?: SellerAdminChatAttachment | null;
};

export type SellerAdminChatVoiceCallItem = {
  kind: "voice_call";
  id: number;
  created_at: string;
  voice_call: {
    was_answered: boolean;
    status?: string;
    duration_label?: string | null;
    label: string;
    is_outgoing: boolean;
  };
};

export type SellerAdminChatTimelineItem =
  | SellerAdminChatMessage
  | SellerAdminChatVoiceCallItem;

export function isVoiceCallTimelineItem(
  item: SellerAdminChatTimelineItem,
): item is SellerAdminChatVoiceCallItem {
  return item.kind === "voice_call";
}

export type SellerAdminChatInboxResponse = {
  success: boolean;
  data: {
    contacts: SellerAdminChatContact[];
    total_unread: number;
    voice?: SellerAdminChatVoiceStatus;
    urls?: {
      voice_token?: string;
    };
  };
};

export type SellerAdminChatMessagesResponse = {
  success: boolean;
  data: {
    messages: SellerAdminChatMessage[];
    voice_calls?: SellerAdminChatVoiceCallItem[];
    meta: {
      current_page: number;
      last_page: number;
      total: number;
    };
  };
};
